module.exports = __webpack_public_path__ + "static/media/adresse.b66f4c98.png";